import type { AllRouteEndpoints } from "../routeTypes";
export const sdkDebuggerDocumentCacheKeys: AllRouteEndpoints[] = ["/sdk/debugger/:app_group_id/all"];
